import { Component, computed, inject } from '@angular/core';
import { AuthService } from '@core/auth/services/auth.service';
import { SiHeaderDropdownComponent, SiHeaderDropdownTriggerDirective } from '@siemens/element-ng/header-dropdown';
import { SiAvatarComponent } from '@siemens/element-ng/avatar';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    imports: [SiHeaderDropdownComponent, SiHeaderDropdownTriggerDirective, SiAvatarComponent]
})
export class UserComponent {
    private readonly authService = inject(AuthService);

    protected readonly userName = this.authService.userName;
    protected readonly userPhoto = this.authService.userPhoto;
    protected readonly userOrgCode = computed(() => this.authService.userIdTokenClaims()?.org_code ?? '');
    protected readonly userInitials = computed(() => {
        const claims = this.authService.userIdTokenClaims();
        const givenName = claims?.preferred_given_name ?? claims?.given_name ?? '';
        const familyName = claims?.preferred_family_name ?? claims?.family_name ?? '';
        return `${givenName.charAt(0)}${familyName.charAt(0)}`.toUpperCase();
    });
}
